<template>
  <div class="leave-meeting">
    <div class="wrapper">
      <img class="over-img" src="~@/assets/img/meetingover_picture.png" />
      <p class="txt">您已离开会议</p>
      <a-button type="primary" class="btn" @click="originGoBack">返回加入会议</a-button>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    originGoBack () {
      this.$router.replace('/login')
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/utils/utils.less';
.leave-meeting {
  width: 100%;
  height: 100%;
  min-width: 960px;
  min-height: 630px;
  position: relative;
  background: url('~@/assets/img/bg2_img.png') no-repeat center 10px;
  background-size: cover;
  .wrapper {
    .centerAbs();
    padding-top: 60px;
    width: 700px;
    height: 450px;
    background: #fff;
    text-align: center;
    box-shadow: 0px 1px 3px 0px rgba(19, 44, 75, 0.07);
    border-radius: 6px;
  }
  .over-img {
    width: 266px;
    height: 222px;
  }
  .txt {
    line-height: 64px;
    color: #42424a;
    font-size: 24px;
  }
  .btn {
    color: #fff;
    background: #5aa4f7;
    border: none;
    padding: 0 30px;
    height: 36px;
  }
}
</style>
